import React from 'react'
import styled from 'styled-components'

const StyledDashedLine = styled.div`
	display: inline-block;
	${(props) =>
		props.invert &&
		`
        transform: rotate(180deg);
    `}

	svg {
		${(props) =>
			props.color &&
			`
            fill: ${props.color};
        `}
	}

	path {
		${(props) =>
			props.color &&
			`
            fill: ${props.color};
            `}
	}
`

/**
 * @constructor
 * @param {boolean} invert - if `true` it rotates 180deg the component
 * @param {string} color - it passes the color to the compoment
 *
 * @example
 * `<DashedLine invert={true} color={PRIMARY_COLOR} /> `
 */
const DashedLine = (props) => (
	<StyledDashedLine className="dashed-line" invert={props.invert}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="110px"
			height="23px"
			viewBox="0 0 110 23"
			preserveAspectRatio="xMidYMid meet">
			<path
				d="M143,163q295,-193,494,3"
				style={{ fill: 'none', stroke: props.color, strokeWidth: '6px' }}
				id="e1_arc2"
				transform="matrix(0.214079 0 0 0.214079 -28.8847 -13.6353)"
				strokeDasharray="20,20"
			/>
		</svg>
	</StyledDashedLine>
)

export default DashedLine
